import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取列表
export const getAgent = params => {
  return axios.request({
    url: "/tracker/agent",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/tracker/agent",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/tracker/agent/${params.id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/tracker/agent/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = params => {
  return axios.request({
    url: `/tracker/agent/${params.id}`,
    method: "DELETE"
  });
};

export function updateFlie(data) {
  return axios.request({
    url: "/tracker/agent/agentUpload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}

export function updateFlieContract(data) {
  return axios.request({
    url: "/tracker/contract/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}

export const save = data => {
  return axios.request({
    url: "/tracker/contract/save/"+data.agentId,
    data,
    method: "post"
  });
};

export const getContract = params => {
  return axios.request({
    url: "/tracker/contract/index/"+params.id,
    params,
    method: "get"
  });
};

export const delContract = data => {
  return axios.request({
    url: "/tracker/contract/delete/"+data.id,
    data,
    method: "post"
  });
}; 

export const contact = params => {
  return axios.request({
    url: "/tracker/contact/index/"+params.id,
    params,
    method: "get"
  });
};

export const contactSave = data => {
  return axios.request({
    url: "/tracker/contact/save/"+data.agentId,
    data,
    method: "post"
  });
}; 

export const bank = params => {
  return axios.request({
    url: "/tracker/bank/index/"+params.id,
    params,
    method: "get"
  });
};

export const bankSave = data => {
  return axios.request({
    url: "/tracker/bank/save/"+data.agentId,
    data,
    method: "post"
  });
}; 

export const bankDel = data => {
  return axios.request({
    url: "/tracker/bank/delete/"+data.id,
    data,
    method: "post"
  });
}; 

export const cancel = data => {
  return axios.request({
    url: "/tracker/contract/cancel/"+data.id,
    data,
    method: "post"
  });
}; 